import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Flex } from "@rpi/openapi-core";
import { Body, Label } from "./Typography";
import { FieldInfoTooltip } from "./FieldInfoTooltip";

const useStyles = createStyles(() => ({
  field: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[1],
    flex: "1 0 0",
    minWidth: 0,
  },
}));

/** A field label with an optional info tooltip, above its value. Shared across order detail views. */
export const DetailField: React.FC<{
  label: string;
  children: React.ReactNode;
  tooltip?: string;
  testId?: string;
}> = ({ label, children, tooltip, testId }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.field} data-testid={testId}>
      <Flex.Row gap={4} align="center">
        <Label>{label}</Label>
        {tooltip && <FieldInfoTooltip label={label} content={tooltip} />}
      </Flex.Row>
      <Body>{children}</Body>
    </div>
  );
};
